<template lang="pug">
UiModal(
  :show="show"
  :title="isInvite ? $t('companies.users.invite_title') : $t('companies.users.edit_title')"
  :subtitle="isInvite ? $t('companies.users.invite_description') : $t('companies.users.edit_description')"
  @close="close"
  :rightActions="rightActions"
)
  UiFormGroup(
    :label="$t('companies.users.name')"
    label-for="name-input"
    label-cols="4"
    :vuelidateModel="v$.form.name"
  )
    UiInput#name-input(
      v-model="form.name"
      :error="v$.form.name.$error"
    )

  UiFormGroup(
    :label="$t('companies.users.email')"
    :vuelidateModel="v$.form.email"
  )
    UiInput#email-input(
      v-model="form.email"
      type="email"
      :error="v$.form.email.$error"
    )

  UiFormGroup(
    :label="$t('companies.users.role')"
    :vuelidateModel="v$.form.role"
  )
    UiMultiselect#role-input(
      v-model="form.role"
      :options="rolesOptions"
      :error="v$.form.role.$error"
      :canClear="false"
      :canDeselect="false"
    )
</template>

<script>
import ApiCompanyUsers from "@/api/companyUsers.js";
import useVuelidate from "@vuelidate/core";
import { email, required } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      form: {
        name: {
          required,
        },
        email: {
          required,
          email,
        },
        role: {
          required,
        },
      },
    };
  },

  data() {
    return {
      show: false,
      isInvite: false,
      companyId: null,
      form: {
        name: "",
        email: "",
        role: null,
      },
      rolesOptions: [
        { label: "Admin", value: "admin" },
        { label: "Reader", value: "reader" },
      ],
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },
  },

  methods: {
    open(companyId, User) {
      this.v$.$reset();
      if (User) {
        this.isInvite = false;
        this.form = {
          id: User.id,
          name: User.name,
          email: User.email,
          role: User.role,
        };
      } else {
        this.isInvite = true;
        this.form = {
          name: "",
          email: "",
          role: "reader",
        };
      }
      this.companyId = companyId;
      this.show = true;
    },

    close() {
      this.show = false;
    },

    save() {
      this.v$.$validate().then((res) => {
        if (!res) return;
        const form = this.form;
        const params = {
          name: form.name,
          email: form.email,
          role: form.role,
        };
        const companyId = this.companyId;
        if (this.isInvite) {
          ApiCompanyUsers.inviteUser(companyId, params)
            .then((res) => {
              this.$emit("done");
              this.close();
            })
            .catch((e) => {});
        } else {
          ApiCompanyUsers.updateUser(companyId, form.id, params)
            .then((res) => {
              this.$emit("done");
              this.close();
            })
            .catch((e) => {});
        }
      });
    },
  },
};
</script>
